<template>
  <div>
    <b-container>
      <ifka-vp-login-form />
    </b-container>
  </div>
</template>
<script>
import LoginForm from '../components/LoginForm.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Login',
  components: {
    ifkaVpLoginForm: LoginForm
  },
  computed: {
    ...mapGetters(['isAuthenticated'])
  },
  created() {
    this.$gtag.event('user_login', {
      event_category: 'user_interaction'
    })
    if (this.isAuthenticated) this.$router.push('/home')
  }
}
</script>

<style scoped>
.bordered-container {
  max-width: 600px;
  margin: 0;
}
</style>
